import { render, staticRenderFns } from "./ChartBaseSwitch.vue?vue&type=template&id=a5ec903c&"
import script from "./ChartBaseSwitch.vue?vue&type=script&lang=js&"
export * from "./ChartBaseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports